import type { PickerDisplayConfigMap } from '~/scopes/product-core/components/presentationals/CustomizationFunnelCondensed/CustomizationFunnelCondensed.types'

/** Matches Tailwind's `md` breakpoint. */
export const DESKTOP_BREAKPOINT = 768

export const PICKER_DISPLAYS = {
  STACKED: 'STACKED',
  HORIZONTAL: 'HORIZONTAL',
  ZGRID: 'ZGRID',
} as const

export const DEFAULT_PICKER_DISPLAY = PICKER_DISPLAYS.STACKED

export type PickerDisplay =
  (typeof PICKER_DISPLAYS)[keyof typeof PICKER_DISPLAYS]

/**
 * Picker display config for the condensed funnel, from the Q3 2026
 * Condensed M&M funnel PRD ("Picker logic by category").
 *
 * Keyed by picker id, then by device column. When a picker/category
 * combination is not specified, the default display is STACKED.
 */
export const PICKER_DISPLAY_CONFIG: PickerDisplayConfigMap = {
  grades: {
    SMARTPHONE: { display: DEFAULT_PICKER_DISPLAY },
    MACBOOK: { display: DEFAULT_PICKER_DISPLAY },
    LAPTOP: { display: DEFAULT_PICKER_DISPLAY },
    TABLET: { display: DEFAULT_PICKER_DISPLAY },
  },
  battery: {
    SMARTPHONE: { display: PICKER_DISPLAYS.HORIZONTAL },
    MACBOOK: { display: DEFAULT_PICKER_DISPLAY },
    LAPTOP: { display: PICKER_DISPLAYS.HORIZONTAL },
    TABLET: { display: PICKER_DISPLAYS.HORIZONTAL },
  },
  storage: {
    SMARTPHONE: {
      display: PICKER_DISPLAYS.ZGRID,
      maxOptions: 3,
    },
    MACBOOK: { display: PICKER_DISPLAYS.ZGRID, maxOptions: 3 },
    LAPTOP: { display: PICKER_DISPLAYS.ZGRID, maxOptions: 3 },
    TABLET: { display: PICKER_DISPLAYS.ZGRID, maxOptions: 3 },
  },
  memory: {
    MACBOOK: { display: PICKER_DISPLAYS.ZGRID, maxOptions: 3 },
    LAPTOP: { display: PICKER_DISPLAYS.ZGRID, maxOptions: 3 },
  },
  screen_size: {
    MACBOOK: { display: PICKER_DISPLAYS.ZGRID, maxOptions: 3 },
    LAPTOP: { display: DEFAULT_PICKER_DISPLAY },
  },
  keyboard_type_language: {
    MACBOOK: { display: DEFAULT_PICKER_DISPLAY },
    LAPTOP: { display: DEFAULT_PICKER_DISPLAY },
  },
  processor: {
    MACBOOK: { display: DEFAULT_PICKER_DISPLAY },
    LAPTOP: { display: DEFAULT_PICKER_DISPLAY },
  },
  network: {
    TABLET: { display: PICKER_DISPLAYS.HORIZONTAL },
  },
  dual_sim: {
    SMARTPHONE: { display: DEFAULT_PICKER_DISPLAY },
  },
  color: {
    SMARTPHONE: { display: PICKER_DISPLAYS.ZGRID },
    MACBOOK: { display: PICKER_DISPLAYS.ZGRID },
    LAPTOP: { display: PICKER_DISPLAYS.ZGRID },
    TABLET: { display: PICKER_DISPLAYS.ZGRID },
  },
  band_color: {
    SMARTPHONE: { display: PICKER_DISPLAYS.ZGRID },
    MACBOOK: { display: PICKER_DISPLAYS.ZGRID },
    LAPTOP: { display: PICKER_DISPLAYS.ZGRID },
    TABLET: { display: PICKER_DISPLAYS.ZGRID },
  },
} as const
